module.exports = __webpack_public_path__ + "img/location.9f0f0e55.svg";